"use strict";
/*
 *@description: 测评弹窗模块
 *
 *@author: qiuhongyang
 *@date: 2021-03-25 09:06:28
 *
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// C1 - 保守型
// C2 - 谨慎型
// C3 - 稳健型
// C4 - 积极型
// C5 - 激进型
var dot_1 = __importDefault(require("dot"));
var tpl_cp_result = require("./cp_result.html"); // 测评结果
var tpl_cp_risk = require("./cp_risk.html"); // 风险测评 风险提示 风险等级不匹配等
var tpl_cp_tips = require("./cp_tips.html"); // 已达上限、确认提交等普通提示
var tpl_cp_question = require("./cp_question.html"); // 问卷题目
;
/*
* 问卷题目
*/
var cp_question_model = {
    options: {
        subcallback: Function
    },
    init: function (opt) {
        var _this_1 = this;
        var defaultopt = {
            content: "",
            boxid: "body",
            callback: null,
            width: 298,
            height: 218,
            tipinfos: '',
            subtext: "确认",
            showclose: true,
            showsubbtn: true,
            showresetbtn: true,
            datalist: [] //题目相关信息
        };
        this.options = $.extend({}, defaultopt, opt);
        var htmlstr = dot_1.default.template(tpl_cp_question)(this.options);
        $("body").append($(htmlstr));
        $('body').addClass('model-active');
        setTimeout(function () {
            _this_1.bindevent();
        }, 500);
    },
    removemodel: function () {
        $('body').removeClass('model-active');
        $("._cp_question_model").remove();
    },
    bindevent: function () {
        var that = this;
        $("._cp_question_model").on('click', '.model_shadow', function () {
            // that.removemodel();
        });
        $("._cp_question_model").on('click', '.sure_btn', function () {
            var _checkeds = $("#cp_question_box").find(".checked");
            var ids = Array.from(_checkeds).map(function (v) {
                var _this = $(v);
                var id = _this.attr("data-sn"), answers = _this.attr("data-select") || "";
                var subarr = answers.split("") || [];
                return {
                    id: id,
                    answers: subarr
                };
            });
            var subcallback = that.options.subcallback;
            if (subcallback) {
                subcallback(ids);
            }
            ;
            // that.removemodel();
            return false;
        });
        $("._cp_question_model").on('click', '.cancel_btn', function () {
            that.removemodel();
            return false;
        });
        $("._cp_question_model").on('click', '.model_close', function () {
            that.removemodel();
        });
        // qtype1单选 复选控制
        $(".qtype1").on("click", "i", function () {
            var $el = $(this), _sn = $el.data("sn");
            $el.removeClass("check").addClass("hascheck");
            $el.parents(".qchild").siblings().find("i").removeClass("hascheck").addClass("check");
            $el.parents(".qitem").addClass("checked");
            $el.parents(".qitem").attr("data-select", _sn);
        });
        // 复选
        $(".qtype2").on("click", "i", function () {
            var $el = $(this), _sn = $el.data("sn");
            var selecteds = $el.parents(".qitem").attr("data-select") || "";
            if ($el.hasClass("hascheck")) {
                $el.removeClass("hascheck").addClass("check");
                selecteds = selecteds.replace(new RegExp(_sn, 'g'), "");
            }
            else {
                $el.removeClass("check").addClass("hascheck");
                selecteds += _sn + "";
            }
            ;
            if (selecteds) {
                $el.parents(".qitem").addClass("checked");
            }
            else {
                $el.parents(".qitem").removeClass("checked");
            }
            $el.parents(".qitem").attr("data-select", selecteds);
        });
    }
};
/*
* 测评结果模态框
*/
var cp_result_model = {
    options: {
        subcallback: Function,
        subcallback2: Function
    },
    init: function (opt) {
        var _this_1 = this;
        var defaultopt = {
            content: "",
            boxid: "body",
            callback: null,
            width: 298,
            height: 218,
            tipinfos: '',
            subtext: "确认",
            resulttxt: "C4-积极型",
            iconname: "cp_icon_jiji",
            cptime: "2021-03-19",
            showclose: true,
            showsubbtn: true,
            showresetbtn: true
        };
        this.options = $.extend({}, defaultopt, opt);
        var htmlstr = dot_1.default.template(tpl_cp_result)(this.options);
        $("body").append($(htmlstr));
        $('body').addClass('model-active');
        setTimeout(function () {
            _this_1.bindevent();
        }, 500);
    },
    removemodel: function () {
        $('body').removeClass('model-active');
        $("._cp_result_model").remove();
    },
    bindevent: function () {
        var that = this;
        $("._cp_result_model").on('click', '.model_shadow', function () {
            // that.removemodel();
        });
        $("._cp_result_model").on('click', '.sure_btn', function () {
            var subcallback = that.options.subcallback;
            if (subcallback) {
                subcallback();
            }
            ;
            that.removemodel();
            return false;
        });
        $("._cp_result_model").on('click', '.cancel_btn', function () {
            var subcallback2 = that.options.subcallback2;
            if (subcallback2) {
                subcallback2();
            }
            ;
            that.removemodel();
            return false;
        });
        $("._cp_result_model").on('click', '.model_close', function () {
            that.removemodel();
        });
    }
};
/*
* 风险提示等模态框
*/
// 不匹配  .cp_icon_matching
// 风险提示.cp_icon_risknotice
// 风险评测 .cp_icon_evaluating
var cp_risk_model = {
    options: {
        subcallback: Function,
        subcallback2: Function,
        closeCallback: Function // 关闭弹窗回调
    },
    init: function (opt) {
        var _this_1 = this;
        var defaultopt = {
            content: "",
            boxid: "body",
            callback: null,
            width: 298,
            height: 218,
            tipinfos: '',
            subtext: "确认",
            subtext2: "取消",
            tiptext: "风险提示",
            iconname: "cp_icon_risknotice",
            cpinfos: "",
            showclose: true,
            showsubbtn: true,
            showsubbtn2: false
        };
        this.options = $.extend({}, defaultopt, opt);
        $("._cp_risk_model").remove();
        var htmlstr = dot_1.default.template(tpl_cp_risk)(this.options);
        $("body").append($(htmlstr));
        $('body').addClass('model-active');
        setTimeout(function () {
            _this_1.bindevent();
        }, 500);
    },
    removemodel: function () {
        $('body').removeClass('model-active');
        $("._cp_risk_model").remove();
    },
    bindevent: function () {
        var that = this;
        $("._cp_risk_model").on('click', '.model_shadow', function () {
            // that.removemodel();
        });
        $("._cp_risk_model").on('click', '.sure_btn', function () {
            var subcallback2 = that.options.subcallback2;
            if (subcallback2) {
                subcallback2();
            }
            ;
            that.removemodel();
            return false;
        });
        $("._cp_risk_model").on('click', '.cancel_btn', function () {
            var subcallback = that.options.subcallback;
            if (subcallback) {
                subcallback();
            }
            ;
            that.removemodel();
            return false;
        });
        $("._cp_risk_model").on('click', '.model_close', function () {
            var closeCallback = that.options.closeCallback;
            closeCallback && closeCallback();
            that.removemodel();
        });
    }
};
/*
* 上限提示  确认提交 未完提示
*/
var cp_tip_model = {
    options: {
        subcallback: Function,
        subcallback2: Function //取消按钮回调
    },
    init: function (opt) {
        var _this_1 = this;
        var defaultopt = {
            content: "",
            boxid: "body",
            callback: null,
            width: 298,
            height: 218,
            tipinfos: '',
            subbtntext: "确认",
            cancelbtntext: "取消",
            iconname: "cp_icon_submit",
            cpinfos: "warm",
            showclose: true,
            showsubbtn: true,
            showcancelbtn: true
        };
        this.options = $.extend({}, defaultopt, opt);
        var htmlstr = dot_1.default.template(tpl_cp_tips)(this.options);
        $("body").append($(htmlstr));
        $('body').addClass('model-active');
        setTimeout(function () {
            _this_1.bindevent();
        }, 500);
    },
    removemodel: function () {
        $('body').removeClass('model-active');
        $("._cp_tip_model").remove();
    },
    bindevent: function () {
        var that = this;
        $("._cp_tip_model").on('click', '.model_shadow', function () {
            that.removemodel();
        });
        $("._cp_tip_model").on('click', '.sure_btn', function () {
            var subcallback = that.options.subcallback;
            if (subcallback) {
                subcallback();
            }
            ;
            that.removemodel();
            return false;
        });
        $("._cp_tip_model").on('click', '.cancel_btn', function () {
            var subcallback2 = that.options.subcallback2;
            if (subcallback2) {
                subcallback2();
            }
            ;
            that.removemodel();
            return false;
        });
        $("._cp_tip_model").on('click', '.model_close', function () {
            that.removemodel();
        });
    }
};
exports.default = {
    questionModel: cp_question_model,
    resultModel: cp_result_model,
    riskModel: cp_risk_model,
    tipModel: cp_tip_model
};
//# sourceMappingURL=data:application/json;base64,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